import Vue from 'vue';
import routeService from './route_service.js';


export default class LlamadaService {
	sendPost(url, data) {
		Vue.http.interceptors.push(function () {
			return function (response) {
				if (response.status == 403) {
					routeService.goToLogin();
				}
				return response;

			};
		});
		return Vue.http.post(url, data, { responseType: 'json' });
	}

	sendGet(url, data) {
		Vue.http.interceptors.push(function () {
			return function (response) {
				if (response.status == 403) {
					routeService.goToLogin();
				}
				return response;
			};
		});
		return Vue.http.get(url, { responseType: 'json', params: data });
	}

	sendFormData(url, data, params) {
		Vue.http.interceptors.push(function () {
			return function (response) {
				if (response.status == 403) {
					routeService.goToLogin();
				}
				return response;

			};
		});
		return Vue.http.post(url, data, { responseType: 'json', params: params });
	}
}